// extracted by mini-css-extract-plugin
module.exports = {"snackBarWrapper":"MuiSnackbarItem_snackBarWrapper__9QfHG","snackBarAlert":"MuiSnackbarItem_snackBarAlert__l92C_"};